<template>
  <div>
    <nav v-if="prevRoute && prevRoute.name">
      <router-link :to="{ name: prevRouteName }"><el-button type="primary" icon="el-icon-arrow-left">Back to {{routeLabel(prevRouteName)}}</el-button></router-link>
    </nav>
    <el-container class="container">
      <main>
        <register />
      </main>
      <aside>
        <login :accountExists="accountExists"/>
      </aside>
    </el-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import login from '../components/login'
  import register from '../components/register'
  import sessionMixin from '../mixins/sessionMixin'

  export default {
    mixins: [sessionMixin],
    props: ['accountExists'],
    components: {
      login,
      register
    },
    computed: {
      ...mapState({
        user: state => state.session.user,
      })
    },
    created() {
      if (this.user) {
        this.$router.push({name: 'profile', params: { redirect: this.getRedirect()}})
        return
      }
    }
  }
</script>
